"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MINT_SEED = exports.POSITION_ACCOUNT_SEED = exports.OPEN_ORDERS_SEED = exports.AUTHORITY_SEED = void 0;
exports.AUTHORITY_SEED = Buffer.from('authority-seed');
exports.OPEN_ORDERS_SEED = Buffer.from('open-orders-seed');
exports.POSITION_ACCOUNT_SEED = Buffer.from('position-account-seed');
exports.MINT_SEED = Buffer.from('mint-seed');
